import { render } from "./OneInstructionsComponent.vue?vue&type=template&id=3f311ad2&scoped=true"
const script = {}

import "./OneInstructionsComponent.vue?vue&type=style&index=0&id=3f311ad2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f311ad2"]])

export default __exports__